module.exports = __webpack_public_path__ + "static/media/manufacturing-microone-01 2.4b6458a8.png";